export const Wordmark = ({ className = "h-8" }: { className?: string }) => (
  <img src="/wordmark.webp" alt="Wardrobe Index" className={`${className} w-auto object-contain select-none`} draggable={false} />
);
